import { dshSessionKey, type DshSessionScope } from './dsh-session-journal';

const STORAGE_KEY = 'borgee:dsh-session:hidden-receipts';
const CAPACITY = 500;
interface HiddenReceipt { scope: string; messageId: string }

export function createDshReceiptDismissals() {
  let retained: HiddenReceipt[] = [];
  const merge = (entries: HiddenReceipt[]) => {
    const unique = new Map<string, HiddenReceipt>();
    for (const entry of entries) {
      const key = JSON.stringify([entry.scope, entry.messageId]);
      unique.delete(key);
      unique.set(key, entry);
    }
    return [...unique.values()].slice(-CAPACITY);
  };
  const load = () => {
    try {
      const parsed: unknown = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '[]');
      const stored = Array.isArray(parsed) ? parsed.filter((entry): entry is HiddenReceipt =>
        !!entry && typeof entry === 'object' && typeof entry.scope === 'string' && typeof entry.messageId === 'string',
      ).slice(-CAPACITY) : [];
      retained = merge([...stored, ...retained]);
    } catch {
      // A failed storage read must not revive receipts hidden in this tab.
    }
    return retained;
  };
  const forScope = (scope: DshSessionScope) => new Set(retained.filter(entry => entry.scope === dshSessionKey(scope)).map(entry => entry.messageId));
  return {
    read(scope: DshSessionScope): Set<string> {
      load();
      return forScope(scope);
    },
    hide(scope: DshSessionScope, messageId: string): Set<string> {
      retained = merge([...load(), { scope: dshSessionKey(scope), messageId }]);
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(retained));
      } catch {
        // Retain all hidden identities in memory until a later write succeeds.
      }
      return forScope(scope);
    },
  };
}

export const dshReceiptDismissals = createDshReceiptDismissals();
